<template>
  <div class="page">
    <back-navigation-header :on-back="onBack"/>
    <div class="reset-password-mail">
      <div class="content">
        <img :src="require('@/assets/2fa-login/mail_icon.svg')" class="mail-img">
        <div class="mini-title r-typo-headline-label">איפוס סיסמה</div>
        <div class="title r-typo-headline">שלחנו לך מייל, נמשיך את התהליך שם</div>
        <span class="text">אפשר לבדוק את המייל,
        <span class="bold">מחכה לך לינק</span>
        להמשך תהליך איפוס הסיסמה
        </span>
      </div>
    </div>
    <login-support-footer-positioned/>
  </div>

</template>

<script>

import BackNavigationHeader from '@/base-components/app-header/BackNavigationHeader.vue';
import router from '@/router';
import Segment from '@/Segment';
import LoginSupportFooterPositioned from '@/base-components/LoginSupportFooterPositioned';

export default {
  name: 'TwofaResetPassword',
  async created() {
    Segment.trackUserGot('2faPasswordResetEmailSent');
  },
  methods: {
    onBack() {
      router.go(-1);
    },
  },
  components: {
    LoginSupportFooterPositioned,
    BackNavigationHeader,
  },
};
</script>

<style lang="scss" scoped>
@import 'src/scss/mixins';
@import "~base-ui/src/scss/riseup-colors";

.page {
  height: 100%;

  display: flex;
  flex-direction: column;
}

.reset-password-mail {
  justify-content: space-between;
}

.content {
  margin: 65px 30px 30px 30px;
}

.mail-img {
  width: 15%;
}

.mini-title {
  padding-top: 40px;
}

.title {
  padding: 15px 0;
}

.text {
  font-size: 18px;
  line-height: 26px;

  .bold {
    font-weight: bold;
  }
}

</style>
